import request from "@/utils/request";

// 商家查询审批记录接口
export function getQryRecord(data) {
  return request({
    url: "/apis/sra/store/users/signup/qryRecord", // 后端接口
    method: "post",
    data
  });
}
